import { SelectedMealFilters } from 'types/internal'
import { getSoleSelectedFilterKey } from 'utils/menus'

export interface FilterTheme {
  backgroundClassName: string
}

const FILTER_THEMES: Record<string, FilterTheme> = {
  longevity: { backgroundClassName: 'bg-navy' },
}

/**
 * A theme only applies when its filter is the *sole* selected filter, so the
 * branded section can never span meals that another filter also narrowed down.
 */
export function getSelectedFilterTheme({
  isEnabled,
  selectedMealFilters,
}: {
  isEnabled: boolean
  selectedMealFilters: SelectedMealFilters
}): FilterTheme | null {
  if (!isEnabled) {
    return null
  }

  const filterKey = getSoleSelectedFilterKey(selectedMealFilters)

  return filterKey ? (FILTER_THEMES[filterKey] ?? null) : null
}
